module.exports = __webpack_public_path__ + "media/MRI3-ad.5faba45c.mp3";